import {
  ODButton,
  ODButtonSize,
  ODButtonTheme,
  ODListablePaginatedTable2,
  ODListablePagination,
  ODWebUtils,
  useCounter,
  useODListableContext,
} from '@odc/od-react-belt'
import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'
import { GQLDirectAds } from '../../../@types/server'
import { HoverTR } from '../../../components/commonStyle'
import { COLORS } from '../../../styles/colors'
import { SiteUrls } from '../../../urls'
import {
  DirectAdsPrimaryKey,
  IDirectAdsListableOption,
} from '../DirectAdsCommon'
import { useDirectAdsListDataLoader } from './DirectAdsListDataLoader'

interface IDirectAdsListableTableProps {}

export const DirectAdsListableTable: React.FC<IDirectAdsListableTableProps> = (
  props
) => {
  const { Provider, Context } = useODListableContext<
    GQLDirectAds,
    IDirectAdsListableOption
  >()
  const [token] = useCounter()
  const dataLoader = useDirectAdsListDataLoader()
  const [redirect, setRedirect] = React.useState('')

  if (redirect) {
    return <Redirect to={redirect} />
  }

  return (
    <Provider
      dataLoader={dataLoader}
      keyExtractor={(v) => v[DirectAdsPrimaryKey].toString()}
      pageSize={10}
      refreshToken={token.toString()}
      onDataLoaderError={ODWebUtils.showError}
      searchOnLoad
    >
      <Card style={{ flexGrow: 2 }}>
        <CardBody>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              marginBottom: 15,
            }}
          >
            <Link
              to={SiteUrls.Admin.DirectAds.Create}
              style={{ textDecoration: 'none' }}
            >
              <ODButton
                theme={ODButtonTheme.Primary}
                size={ODButtonSize.Small}
                style={{ minWidth: 135, borderRadius: 5 }}
              >
                생성
              </ODButton>
            </Link>
          </div>
          <ODListablePaginatedTable2
            numColumns={9}
            listableContext={Context}
            renderHeader={() => (
              <tr>
                <th>아이디</th>
                <th>타입</th>
                <th>타이틀</th>
                <th>이미지</th>
                <th>링크</th>
                <th>aOS 폴백링크</th>
                <th>iOS 폴백링크</th>
                <th>숨김?</th>
              </tr>
            )}
            renderRow={(value: GQLDirectAds) => (
              <HoverTR
                key={value.directAdsId}
                onClick={() =>
                  setRedirect(SiteUrls.Admin.DirectAds.Edit(value.directAdsId))
                }
              >
                <td>{value.directAdsId}</td>
                <td>{value.type}</td>
                <td>{value.title}</td>
                <td>
                  {value.imageFile?.link ? (
                    <img
                      src={value.imageFile.link}
                      width={150}
                      height={150}
                      alt="cover"
                    />
                  ) : (
                    <span>미등록</span>
                  )}
                </td>
                <td>{value.link}</td>
                <td>{value.aOSFallbackLink}</td>
                <td>{value.iOSFallbackLink}</td>
                <td>
                  {value.isHidden ? (
                    <span style={{ fontWeight: 'bold', color: COLORS.Primary }}>
                      Y
                    </span>
                  ) : (
                    <span style={{ color: COLORS.GRAY600 }}>N</span>
                  )}
                </td>
              </HoverTR>
            )}
            eventParentContext={{}}
          />
          <ODListablePagination hideIfSinglePage listableContext={Context} />
        </CardBody>
      </Card>
    </Provider>
  )
}
